import { api } from '../apiClient'
import type { Job, CreateJobRequest } from '../../types'

export async function checkPostcodeAvailability(postcode: string): Promise<{
  available: boolean
  plumberCount: number
  fastestEtaMinutes?: number
  priceFrom?: number
  jobRef?: string
}> {
  const res = await api.get('/api/jobs/availability', { params: { postcode } })
  return res.data
}

export async function reportFunnelStep(data: {
  jobRef: string
  step: 'postcode' | 'category' | 'phone' | 'address'
  postcode?: string
  plumberCount?: number
  category?: string
  subSelections?: string[]
  phone?: string
  email?: string
  address?: string
}): Promise<void> {
  await api.post('/api/jobs/funnel-step', data)
}

export async function createJob(data: CreateJobRequest): Promise<{ jobId: string; jobRef: string; jobSecret: string; status: string; sessionUrl?: string }> {
  const res = await api.post('/api/jobs', data)
  return res.data
}

export async function getJob(jobId: string): Promise<Job> {
  const res = await api.get(`/api/jobs/${jobId}`)
  return res.data
}

export async function cancelJob(jobId: string, jobSecret: string): Promise<void> {
  await api.post(`/api/jobs/${jobId}/cancel`, {}, { headers: { 'X-Job-Secret': jobSecret } })
}

export async function triggerMockPayment(jobId: string): Promise<void> {
  await api.post(`/api/jobs/${jobId}/mock-payment`)
}

export async function createJobPaymentIntent(jobId: string): Promise<{ clientSecret: string }> {
  const res = await api.post(`/api/jobs/${jobId}/create-payment-intent`)
  return res.data
}

export async function applyJobCoupon(jobId: string, code: string): Promise<{
  amountGbp: number
  originalAmountGbp: number
  discountGbp: number
  code: string
  description: string
  fullyDiscounted: boolean
}> {
  const res = await api.post(`/api/jobs/${jobId}/apply-coupon`, { code })
  return res.data
}

export async function updateJobDetails(jobId: string, jobSecret: string, data: { address?: string; email?: string }): Promise<void> {
  await api.patch(`/api/jobs/${jobId}/details`, data, { headers: { 'X-Job-Secret': jobSecret } })
}

export async function selectPlumber(jobId: string, jobSecret: string, plumberId: string): Promise<void> {
  await api.post(`/api/jobs/${jobId}/select`, { plumberId }, { headers: { 'X-Job-Secret': jobSecret } })
}
